import React, { useState, useEffect } from 'react';
import MenuItem from './MenuItem';

import './Menu.css'; // Assurez-vous de créer ce fichier CSS pour le style

const Menu = ({ addToCart }) => {
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState('entrées');
  const [subCategories, setSubCategories] = useState({});

  useEffect(() => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        const itemsBySubCategory = data.categories[category].reduce((acc, item) => {
          if (!acc[item['sous-categ']]) {
            acc[item['sous-categ']] = [];
          }
          acc[item['sous-categ']].push(item);
          return acc;
        }, {});
        setItems(data.categories[category]);
        setSubCategories(itemsBySubCategory);
      })
      .catch(error => console.error('Erreur lors de la récupération des données:', error));
  }, [category]);

  const handleCategoryChange = (newCategory) => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        const itemsBySubCategory = data.categories[newCategory].reduce((acc, item) => {
          if (!acc[item['sous-categ']]) {
            acc[item['sous-categ']] = [];
          }
          acc[item['sous-categ']].push(item);
          return acc;
        }, {});
        setItems(data.categories[newCategory]);
        setSubCategories(itemsBySubCategory);
      })
      .catch(error => console.error('Erreur lors de la récupération des données:', error));
    setCategory(newCategory);
  };

  // Log categories found in JSON and store them in state
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        if (data.categories) {
          const cats = Object.keys(data.categories);
          //console.log('Catégories trouvées:', cats);
          setCategories(cats);
        }
      })
      .catch(error => console.error('Erreur lors de la récupération des catégories:', error));
  }, []);

  return (
    <div>
      <h2>A la carte</h2>
      {/* Ajoutez un conteneur scrollable pour les boutons de catégorie */}
      <div className='category-scroll'>
        <div className='category-buttons'>
          {/* Dynamically generate category buttons from JSON */}
          {categories.map(cat => (
            <button
              key={cat}
              className={category === cat ? 'active' : ''}
              onClick={() => handleCategoryChange(cat)}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>
      </div>
      {/* N'oubliez pas d'ajouter le style CSS pour .category-scroll */}
      <div className='menu-items'>
        {Object.keys(subCategories).map(subCategory => (
          <div key={subCategory} className='sub-category'>
            <h3>{subCategory !== undefined && subCategory !== "undefined" ? subCategory : ''}</h3>
            <div className='carousel'>
              {subCategories[subCategory].map(item => (
                <div key={item.id} className='carousel-item'>
                  <MenuItem item={item} addToCart={addToCart} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;
